import axios, { AxiosInstance } from 'axios';

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

const Axios: AxiosInstance = axios.create({
  baseURL: REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // timeout: 10000,
  // timeout: 100000000,
});

const SetupAxios = (axios: AxiosInstance, store: any) => {
  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: { accessToken },
      } = store.getState();

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }

      return config;
    },
    (err: any) => Promise.reject(err)
  );

  axios.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      return Promise.reject(error);
    }
  );
};

export { Axios, SetupAxios };
